import type { MetadataMap } from '@xing-com/crate-core-assets';
import type { RegisteredExperiment, Variant } from '@xing-com/splitkit';

import {
  shouldRegisterConditionalExperiment,
  shouldRegisterExperiment,
} from './should-register-experiment';

export function getRegisteredExperiments(
  metadataMap: MetadataMap
): RegisteredExperiment[] {
  return Object.values(metadataMap).flatMap(({ contributes }) => {
    const { experiments = [] } = contributes;

    return experiments.map(
      ({ experimentType = 'user', supportedVariants, ...rest }) => {
        return {
          experimentType,
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          supportedVariants: supportedVariants as ['A', ...Variant[]],
          ...rest,
        };
      }
    );
  });
}

export function getGlobalRegisteredExperiments(
  metadataMap: MetadataMap
): RegisteredExperiment[] {
  return getRegisteredExperiments(metadataMap).filter(({ name }) => {
    return shouldRegisterExperiment(name);
  });
}

export function getConditionalRegisteredExperiments(
  metadataMap: MetadataMap,
  viewerCountry?: string
): RegisteredExperiment[] {
  return getRegisteredExperiments(metadataMap).filter(({ name }) => {
    return (
      !shouldRegisterExperiment(name) &&
      shouldRegisterConditionalExperiment(name, viewerCountry)
    );
  });
}
